<h1 [style.color]="primaryColor">
  <ng-content></ng-content>
</h1>
